export const getNotesFrag = `
    id
    note
    date
    folder {
        serviceId
    }
`;
